<template>
<div></div>
</template>
<script>
import { setCookie, getCookie } from "@/utils";

export default {
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name) {
        let token = getCookie('token')
        let userId = getCookie('userid')
        location.href = 'http://wap.ponhu.cn/miniapi/newactivity/index.html#/yearEndCarnival?h5Type=true&token=' + token + '&userId=' + userId
      }
    })
  },
  created () {
    let params = decodeURI(this.$route.query.params).split(',')
    if (params[1]) {
      setCookie('token', params[1])
      setCookie('userid', params[2])
      this.$store.dispatch('LoginByUser', params[1])
    }
    location.href = params[0]
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
</style>
